export type BattlefieldFxBucket = "trailGhost" | "impactFx" | "destroyFx" | "textFx" | "muzzleFx";

export interface BattlefieldFxBudgetLimits {
  readonly trailGhost: number;
  readonly impactFx: number;
  readonly destroyFx: number;
  readonly textFx: number;
  readonly muzzleFx: number;
}

export const DEFAULT_BATTLEFIELD_FX_BUDGET: BattlefieldFxBudgetLimits = {
  trailGhost: 1,
  impactFx: 1,
  destroyFx: 1,
  textFx: 1,
  muzzleFx: 6,
};

/**
 * Per-frame visual FX budget. Gameplay effects still run; this only drops extra
 * cosmetic objects when a high-burst build causes many impacts in one frame.
 */
export class BattlefieldFxBudget {
  private frameTime = Number.NaN;
  private readonly used: Record<BattlefieldFxBucket, number> = {
    trailGhost: 0,
    impactFx: 0,
    destroyFx: 0,
    textFx: 0,
    muzzleFx: 0,
  };

  constructor(private readonly limits: BattlefieldFxBudgetLimits = DEFAULT_BATTLEFIELD_FX_BUDGET) {}

  allow(frameTime: number, bucket: BattlefieldFxBucket, cost = 1): boolean {
    if (frameTime !== this.frameTime) {
      this.frameTime = frameTime;
      this.used.trailGhost = 0;
      this.used.impactFx = 0;
      this.used.destroyFx = 0;
      this.used.textFx = 0;
      this.used.muzzleFx = 0;
    }
    if (this.used[bucket] + cost > this.limits[bucket]) return false;
    this.used[bucket] += cost;
    return true;
  }
}
